import React, { useEffect, useRef } from "react";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { useAuth } from "../auth/FirebaseAuth";
import { getUserById } from "../models/UserFunctions";
import { useAppContext } from "./AppContext";
import {
  getDateFromFlutter,
  getDocDataByRef,
  getFlutterTime,
  getUserDataById,
} from "../models/DataFunctions";
import createDocApi from "../api/database/createDocApi";
import { getOrgById } from "../models/OrgFunctions";

const OnlineStatus = ({ userData }) => {
  const { appState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
};

export default OnlineStatus;

export async function addActivityLog(
  name,
  folder_ref,
  org_id,
  user_id,
  type,
  prefix
) {
  try {
    let userData = null;
    let orgData = null;
    let folderData = null;
    if (user_id) {
      userData = await getUserDataById(user_id);
    }
    if (org_id) {
      orgData = await getOrgById(org_id);
    }
    if (folder_ref) {
      folderData = await getDocDataByRef(folder_ref);
    }
    let body = {
      master_id: folderData?.master_id,
      org_id: orgData?.id,
      folder_ref: folderData?.ref,
      name: name,
      date: getFlutterTime(),
      user_id: userData?.id,
      user_name: userData?.display_name || folderData?.nom,
      org_name: orgData?.name || "Particulier",
      type: type,
    };
    await createDocApi("activity_log", body, prefix);
  } catch (error) {
    console.error("Error creating activity log:", error);
  }
}
